import { EMPTY_FUNCTION } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_40 } from '../../../Button'
import { ICON_HEIGHT_24 } from '../../../Icon'
import { RequestProfileHeaderFooterActionSelectButton } from '../RequestProfileHeaderFooterActionSelectButton'

import * as styles from './RequestProfileHeaderFooterActionButton.module.css'

function RequestProfileHeaderFooterActionButton({
  Icon,
  className = styles.RequestProfileHeaderFooterActionButton,
  interactive = true,
  options,
  qaName,
  text,
  onClick = EMPTY_FUNCTION,
  onSelectOption,
}) {
  return options ? (
    <RequestProfileHeaderFooterActionSelectButton
      Icon={Icon}
      className={className}
      options={options}
      qaName={qaName}
      text={text}
      onSelectOption={onSelectOption}
    />
  ) : (
    <Button.Text
      showTextTooltip
      beforeIconProps={{ Icon, height: ICON_HEIGHT_24 }}
      className={className}
      height={BUTTON_HEIGHT_40}
      interactive={interactive}
      isInline={false}
      qaName={qaName}
      text={text}
      onClick={onClick}
    />
  )
}

export default RequestProfileHeaderFooterActionButton
